import {
    cardLinkError,
    cardLinkErrorLight,
    cardLinkPrimaryColor,
    cardLinkPrimaryLightColor,
} from '@/src/card-linking/components/colors'

const standardButtonStyles: object = {
    width: '100%',
    display: 'block',
    backgroundColor: cardLinkPrimaryColor,
    border: `2px solid ${cardLinkPrimaryColor}`,
    fontSize: '16px',
    color: '#FFF',
    borderRadius: '25px',
    padding: '13px 10px',
    cursor: 'pointer',
    transition: 'all .15s ease-out',
    margin: '10px 0px',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginTop: 10,
    marginBottom: 10,
}

export const standardPrimaryButton: object = {
    ...standardButtonStyles,
    backgroundColor: cardLinkPrimaryColor,
    border: `2px solid ${cardLinkPrimaryColor}`,
    color: '#FFF',
}

export function standardPrimaryButtonOnMouseEnter(e: any) {
    e.currentTarget.style.backgroundColor = cardLinkPrimaryLightColor
    e.currentTarget.style.color = cardLinkPrimaryColor
}

export function standardPrimaryButtonOnMouseLeave(e: any) {
    e.currentTarget.style.backgroundColor = cardLinkPrimaryColor
    e.currentTarget.style.color = '#FFF'
}

export const standardPrimaryLightButton: object = {
    ...standardButtonStyles,
    backgroundColor: '#FFF',
    border: `2px solid ${cardLinkPrimaryColor}`,
    color: cardLinkPrimaryColor,
}

export function standardPrimaryLightButtonOnMouseEnter(e: any) {
    e.currentTarget.style.backgroundColor = cardLinkPrimaryLightColor
}

export function standardPrimaryLightButtonOnMouseLeave(e: any) {
    e.currentTarget.style.backgroundColor = '#FFF'
}

export const defaultDivWrapper = {
    fontFamily: 'sans-serif',
    height: '96%',
    padding: 10,
}

export const defaultHeader = {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    margin: 0,
}

export const defaultBodyText = {
    fontSize: '1rem',
    lineHeight: 1.5,
    color: '#4B5563',
}

export const underlinedBoldBodyText = {
    ...defaultBodyText,
    textDecoration: 'underline',
    fontWeight: 'bold',
    cursor: 'pointer',
    backgroundColor: 'unset',
    border: 'unset',
    fontSize: '1rem',
    color: 'unset',
}

export const errorRedText = {
    margin: 'auto 0px 0px',
    backgroundColor: cardLinkErrorLight,
    border: `1px solid ${cardLinkError}`,
    color: cardLinkError,
    padding: '10px',
    borderRadius: '5px',
    lineHeight: 1.25,
}

export const loadingStyles = {
    fontFamily: 'sans-serif',
    fontSize: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '60vh',
}

export const disclaimerText = {
    fontSize: '.83rem',
    color: '#4B5563',
    paddingBottom: 20,
}
